export default __webpack_public_path__ + "static/media/flag_primaryBlueHover.22f73a56.svg";